<template>
    <section>
        <div class="container-water-fall flex flex_jus_around main" @scroll="scroll">
            <waterfall :col="col" :autoResize="false" :moveTransitionDuration="0.4" :fillBox="true" :list="lists" ref="waterfall">
                <div class="waterfall-item" slot-scope="item">
                    <div class="cell-item hover-time"
                        v-if="item.data.images.length > 0 && item.data">
                        <div v-if="item.data.type === 'seq-news'" @click="itemHandle(item.data)">
                            <div v-if="item.data.typesetting === 1" class="item-body">
                                <div class="item-title">{{item.data.title}}</div>
                                <div class="item-imgs"><img class="waterfall-img" :src="item.data.images[0]" alt="加载错误"></div>
                            </div>
                            <div v-if="item.data.typesetting === 2" class="item-body2 flex flex_jus_between">
                                <div class="item-title">{{item.data.title}}</div>
                                <div class="item-imgs" :style="{backgroundImage: 'url(' + item.data.images[0] + ')'}"></div>
                            </div>
                            <div v-if="item.data.typesetting === 3" class="item-body3">
                                <div class="item-title">{{item.data.title}}</div>
                                <div class="item-imgs flex flex_jus_between">
                                    <img class="waterfall-img" v-for="src in item.data.images" :src="src" alt="加载错误">
                                </div>
                            </div>
                        </div>
                        <div class="news-ad" v-if="item.data.type === 'ad-news-v2-sc'" @click="itemHandle(item.data)">
                        <div class="ad"><img src="../../../assets/AD.png"></div>
                            <div class="item-body">
                                <div class="item-title">{{item.data.title}}</div>
                                <div class="item-imgs"><img :src="item.data.images[0]" alt="加载错误"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </waterfall>
        </div>
        <loading :show="loading"/>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import loading from "./loading.vue";
import waterfall from '@/components/modules/Waterfall.vue';
import utils from '@/utils/index.js';
export default {
	name: 'ChannelItem',
	components: {
        loading,
        waterfall
    },
    computed: {
        ...mapState({
            lists: (state) => state.channel.channleList
        }),
        cid() {
        	return this.$route.params.cid;
        },
    },
	data() {
		return {
			col: utils.loadwaterfallCol(),
            page: 1,
            loading: false
		}
	},
    watch: {
		'$route': function(to, from) {
		 	if(from.name == 'channel' && to.name == 'channel') {
		 		this.page = 1;
		 		this.loading = true;
                this.getItem();
                this.$store.commit('CLEARCHANNELLIST');
		 	}
        },
	},
    mounted() {
        this.getItem();
        
        //监听页面滑动,请求item
        window.addEventListener('scroll', (e) => {
            let bodyTop = document.body.getBoundingClientRect().top;
            let bodyOffsetHeight = document.body.offsetHeight;
            let innerHeight = window.innerHeight;
            if(!this.loading && bodyOffsetHeight - Math.abs(bodyTop) <= 2 * innerHeight && this.$route.name == 'channel') {
                this.getItem();
                this.page += 1;
            }
        });
    },
    methods:{
        scroll(e){
            console.log(e);
        },
        getItem() {
            this.loading = true;
            let params = {
                page: this.page,
                category: this.cid
            };
            this.$store.dispatch('fetch', params).then((data) => {
                this.loading = false;
            });
        },
        itemHandle(item) {
            INFOHUBTACKER({event: 'click',type: item.type});
            // location.href = item.link;
            window.open(item.link);
        }
	}
}
</script>

<style scoped>
.container-water-fall {
  box-sizing: border-box;
}
.cell-item {
    cursor: pointer;
}
.cell-item:hover{
    background-image: linear-gradient(136deg, #ED4D8B 0%, #F05B4A 100%);
    transform: scale(1.03); /* 鼠标放到图片上的时候图片按比例放大0.5倍   */
}
.cell-item .item-body {
    width: 95%;
    margin: 0 auto;
    cursor: pointer;
}
.cell-item .item-body .item-imgs {
    display: block;
    margin: 0 0 0.1rem 0;
    border-radius: 10px;
    overflow: hidden;
}
.item-body .item-title {
    font-family: DINCondensed-Bold;
    font-size: 0.15rem;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 700;
    padding: 0.1rem 0;
}
.cell-item .item-body2 {
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0.1rem 0;
    align-items: center;
}
.cell-item .item-body2 .item-title{
    width: 55%;
    font-family: DINCondensed-Bold;
    font-size: 0.15rem;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 700;
    padding: 0.1rem 0;
}
.item-body2 .item-imgs {
    width: 40%;
    height: 0.9rem;
    display: block;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    background-size:cover ;
}

.cell-item .item-body3 {
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0.05rem 0;
}

.cell-item .item-body3 .item-title {
    font-family: DINCondensed-Bold;
    font-size: 0.15rem;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 700;
    padding: 0.1rem 0;
}

.cell-item .item-body3 .item-imgs img {
    width: 32%;
    border-radius: 10px;
}

.cell-item .item-desc {
    font-size: 15px;
    color: #333333;
    line-height: 15px;
    font-weight: bold;
}
.cell-item {
    width: 96%;
    margin: 0.05rem auto;
    background: #545393;
    border-radius: 8px;
    overflow: hidden;
}
.news-ad {
    position: relative;
}
.news-ad .ad {
    width: 0.2rem;
    height: 0.1rem;
    text-align: center;
    line-height: 0.1rem;
    font-size: 0.08rem;
    color: #FFFFFF;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    right: 0.11rem;
    bottom: 0.05rem;
    z-index: 10;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Channel/ChannelItem.vue